import MaterialAlert, { AlertProps } from '@mui/material/Alert';

export function Alert(props: AlertProps) {
    return <MaterialAlert data-testid={'Alert-container'} {...props} />;
}

export default Alert;
